import { useOrderStore } from '@/stores/order';
import { getReviewStatus } from '@/components/elements/Order/Revisions/composables';
import { useOrderFiles } from '@/stores/orderFiles';
import { useActiveUserStore } from '@/stores/user';
import { storeToRefs } from 'pinia';
import { computed } from 'vue';

export function usePositionFilesInReviewForUser() {
  const orderStore = useOrderStore();
  const filesStore = useOrderFiles();
  const userStore = useActiveUserStore();
  const { files } = storeToRefs(filesStore);
  const { activeUser } = storeToRefs(userStore);
  const { currentOrder } = storeToRefs(orderStore);

  const filesNeedReview = computed(() =>
    files.value.filter(
      (file) =>
        file.positionId &&
        getReviewStatus(file, activeUser.value, currentOrder.value) ===
          'needs-review'
    )
  );

  return {
    filesNeedReview,
  };
}
